var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"qr-image"},[_c(_setup.VueQrcode,{attrs:{"value":_vm.url,"options":{ width: 164, margin: 0, errorCorrectionLevel: 'Q' },"tag":"svg"}}),_c('img',{staticClass:"qr-image__img",attrs:{"src":require('../../../assets/icons/print/qr-icon.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }